module.exports = __webpack_public_path__ + "media/img/about/person/putra-1ae07d9f7f6e5a229b694fde517afd52.webp";